import { Component } from '@angular/core';

@Component({
  selector: 'app-utils-table-skeleton',
  standalone: true,
  templateUrl: './utils-table-skeleton.component.html',
  styleUrl: './utils-table-skeleton.component.scss'
})
export class UtilsTableSkeletonComponent {
  readonly numberOfRows = new Array(20);
  readonly numberOfCols = new Array(15);
}
